import log from "loglevel";

// Set different log levels based on the environment if not explicitly set
if (localStorage.getItem("loglevelset") !== "true") {
    if (process.env.NODE_ENV === "production") {
        log.setLevel("warn"); // Only show warnings and errors in production
    } else {
        log.setLevel("debug"); // Show all logs in development
    }
}

// Expose a function to window to change log level from javascript console
if (typeof window !== "undefined") {
    // Cast window as any to add new property
    (window as any).setLogLevel = (level: log.LogLevelDesc) => {
        log.setLevel(level);
        localStorage.setItem("loglevelset", "true")
        console.log(`Log level set to ${level}`);
        return "Success"
    };
    (window as any).unsetLogLevel = () => {
        localStorage.removeItem("loglevelset");
        return "Success"
    };
}

export default log;
